import React, { useState, useEffect } from 'react';
import { Append_0 } from '../../../../common/constants/Append_0';
import initialImg from '../../../../images/icons/upload_new.svg';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import {
  UserKycUpload,
  UserKycOcr,
  getApiPan,
  UploadFileToS3
} from '../../../../common/constants/api';
import CircularLoading from '../../../../common/components/CircularLoading/CircularLoading';
import _ from 'lodash';
import get from 'lodash/get';
import { useFormikContext } from 'formik';
import { useFormikWizard } from 'formik-wizard';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonDatePicker from '../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import PopUp from '../../../../common/components/PopUp/PopUp';
import { ShowGetImage } from '../../../../common/components/ShowGetImage/ShowGetImage';

const PanDetailsPage = () => {
  const [fileUploadErrors, setFileUploadErrors] = useState({
    file: ''
  });
  const [fileUploaded, setFileUploaded] = useState(false);
  const [fetchInfo, setFetchInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showFullImage, setShowFullImage] = useState(false);
  const [LeadDetails, setLeadDetails] = useState('');
  const [ocrDetails, setOcrDetails] = useState('');
  const [formUpdated, setFormUpdated] = useState(false);
  const [show, setShow] = useState(true);
  const [verifying, setVerifying] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const [case403, setCase403] = useState(false);
  const [ocrError, setOcrError] = useState(false);
  const [s3Img, setS3Img] = useState([]);
  const [userData, setUserData] = useState('');
  const [hasDocuments, setHasDocuments] = useState(null);
  const [Edit, setEdit] = useState(false);
  const [panVerified, setPanVerified] = useState(false);

  const {
    values: data,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm,
    resetForm
  } = useFormikContext();

  const { status } = useFormikWizard();
  const { file, imgUrl, panDetails } = data;

  useEffect(() => {
    const myAsync = async () => {
      let data = getApplicantionInfo();
      const { leadId, leadApplicantId } = data;
      await getApiPan(leadId, leadApplicantId)
        .then(data => {
          if (data.links.length === 0) setHasDocuments(false);
          else {
            let { links, userData } = data;
            setS3Img([links[0].url]);
            setUserData(userData);
            setHasDocuments(true);
            links[0].status == 'AUTO_VERIFIED' ? setPanVerified(true) : '';
            setFieldValue('otherRoute ', true);
          }
        })
        .catch(err => setHasDocuments(false));
    };
    myAsync();
  }, []);

  useEffect(() => {
    if (userData) {
      setFieldValue('panDetails.fullName', userData.name);
      setFieldValue('panDetails.fatherName', userData.fatherName);
      setFieldValue('panDetails.panNumber', userData.panNumber);
      const breakTheDate = userData.dob.toString().split('-');
      setFieldValue('panDetails.year', {
        value: breakTheDate[0],
        label: breakTheDate[0]
      });

      setFieldValue('panDetails.month', {
        value: breakTheDate[1],
        label: breakTheDate[1]
      });
      setFieldValue('panDetails.date', {
        value: breakTheDate[2],
        label: breakTheDate[2]
      });
      setTimeout(() => {
        validateForm();
      }, 1000);
    }
  }, [userData]);

  useEffect(() => {
    setShow(true);
    if (status) setVerifying(false);
    if (status?.message === 'VARIFICATION_SUCCESS') {
      setFieldValue('verified', true);
      setTimeout(() => {
        handleSubmit();
      }, 2000);
    }
  }, [status?.message]);

  useEffect(() => {
    setLeadDetails(getApplicantionInfo());
  }, []);

  useEffect(() => {
    if (!_.isEmpty(ocrDetails.kycEntries)) {
      setFieldValue(
        'panDetails.fullName',
        ocrDetails?.kycEntries?.name?.value || ''
      );
      setFieldValue(
        'panDetails.panNumber',
        ocrDetails?.kycEntries?.panNumber?.value || ''
      );
      setFieldValue(
        'panDetails.fatherName',
        ocrDetails?.kycEntries?.fatherName?.value || ''
      );
      if (ocrDetails?.kycEntries?.dob?.value || false) {
        const breakTheDate = ocrDetails.kycEntries.dob.value
          .toString()
          .split('/');
        if (breakTheDate.length === 3) {
          setFieldValue('panDetails.year', {
            value: breakTheDate[2],
            label: breakTheDate[2]
          });

          setFieldValue('panDetails.month', {
            value: breakTheDate[1],
            label: breakTheDate[1]
          });
          setFieldValue('panDetails.date', {
            value: breakTheDate[0],
            label: breakTheDate[0]
          });
        }
      }
      setFormUpdated(true);
    }
  }, [ocrDetails]);

  useEffect(() => {
    validateForm();
    if (file[0] && file[0][0]) {
      setShow(true);
      setLoading(true);
      UserKycUpload(
        file[0][0],
        LeadDetails.leadId,
        LeadDetails.leadApplicantId,
        'pan'
      )
        .then(data => {
          var { url, fileName, requestId } = data;
          localStorage.setItem('doc_id', JSON.stringify(requestId));
          UploadFileToS3(url, file[0][0], {
            'Content-Type': `${file[0][0].type}`
          })
            .then(res => {
              setFetchInfo(true);

              setTimeout(() => {
                UserKycOcr(
                  LeadDetails.leadId,
                  LeadDetails.leadApplicantId,
                  requestId,
                  'pan'
                )
                  .then(data => {
                    setFileUploaded(true);
                    setOcrDetails(data);
                    setFetchInfo(false);
                    setLoading(false);
                    setShowFullImage(true);
                    validateForm();
                  })
                  .catch(err => {
                    setLoading(false);
                    setOcrError(true);
                  });
              }, 2000);
            })
            .catch(err => console.log(err));
        })
        .catch(err => {
          setLoading(false);
          if (err.response.status === 403) {
            setCase403(false);
            setCase403(true);
          } else {
            setUploadError(false);
            setUploadError(true);
          }
        }); //
    }
    return () => {
      setOcrError(false);
      setShow(false);
      setLoading(false);
      setVerifying(false);
      setUploadError(false);
      setCase403(false);
      setOcrError(false);
    };
  }, [file[0]]);

  useEffect(() => {
    return () => {
      setCase403(false);
      setUploadError(true);
      setVerifying(false);
    };
  }, []);

  return hasDocuments === null ? (
    <div className={'w-full mt-10 mx-auto'}>
      <CircularLoading />
    </div>
  ) : (
    <>
      {ocrError ? (
        <PopUp
          type="fail"
          autoClose={true}
          text={
            'Unabled to Fetch the details, please check the file and try again. .'
          }
          setShow={setShow}
          show={show}
        />
      ) : null}
      {verifying && !status?.message ? (
        <PopUp
          type="loading"
          text={'Verifying your PAN . . .'}
          setShow={setShow}
          show={show}
        />
      ) : null}
      {status ? (
        <>
          {status?.message === 'VARIFICATION_SUCCESS' ? (
            <PopUp
              type="success"
              text={'Pan Card Verified'}
              setShow={setShow}
              show={show}
            />
          ) : null}
          {status?.message === 'VARIFICATION_FAILED' ? (
            <PopUp
              type="fail"
              text={'Pan Card Not Verified,please try again'}
              setShow={setShow}
              show={show}
            />
          ) : null}
          {status?.message !== 'VARIFICATION_FAILED' &&
          status?.message !== 'VARIFICATION_SUCCESS' ? (
            <PopUp
              type="fail"
              text={status?.message}
              autoClose={true}
              setShow={setShow}
              show={show}
            />
          ) : null}
        </>
      ) : null}
      {uploadError ? (
        <PopUp
          type="fail"
          text={'Oops! something went wrong, please try again. . '}
          setShow={setShow}
          show={show}
        />
      ) : null}
      {case403 ? (
        <PopUp
          goto={true}
          dontClose
          autoClose={false}
          type="fail"
          text={"You don't have permission to edit this Lead"}
          setShow={setShow}
          show={show}
        />
      ) : null}
      {loading && !uploadError && !case403 ? (
        <PopUp
          autoClose={false}
          type="loading"
          text={!fetchInfo ? 'Loading ....' : 'Fetching Information . . .'}
          setShow={setShow}
          show={show}
        />
      ) : null}

      <div
        className={
          ' bg-transparent md:bg-white mx-auto md:ml-0 md:mr-auto min-h-screen'
        }
      >
      
        <div
          className={
            ' w-11/12 max-w-md  md:max-w-full  md:w-full  md:p-10 mx-auto' 
          }
        >
      
          <div className="bg-white mx-auto border border-navy-200  md:border-0 w-11/12 px-2 md:px-0 rounded-lg py-4 pb-10  md:py-0 max-w-2xl relative">
          
          {panVerified ? (
          <h2
            className="absolute right-0  font-roboto font-medium  m-2 text-base ml-auto text-green-1000 cursor-pointer"
            onClick={() => {
              setFieldValue('verified', true).then(e => handleSubmit());
            }}
          >
            SKIP
          </h2>
        ) : (
          <></>
        )}  <p className="md:hidden block font-roboto font-normal text-grey-2100 mr-auto py-3 text-sm">
              Upload Your PAN
            </p>
            {s3Img[0] && !Edit ? (
              <div className="ml-2 mt-4">
                <ShowGetImage img={s3Img[0]} setEdit={setEdit} />
              </div>
            ) : (
              <div className="mx-auto flex flex-row justify-center">
                <GlobalUploadComp
                  data={data}
                  imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                  errors={errors}
                  touched={touched}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  setFieldError={setFieldError}
                  showFullImage={showFullImage} // boolean , to change mobile upload image view
                  initialImg={initialImg} // initial image
                  subInst="Upload your PAN"
                  subtext="CHOOSE FILE"
                  resetForm={resetForm}
                />
              </div>
            )}
          </div>
          {(fileUploaded || (s3Img && s3Img.length > 0)) && (
            <div className="form_inputs w-full p-2 flex flex-col md:flex-row md:flex-wrap md:max-w-5xl items-center md:mt-2 justify-around">
              <div className=" md:w-80 w-full  my-4 mx-2 ">
                <CommonInput
                  name="panDetails.fullName"
                  id="fullName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={data.panDetails.fullName}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="Full Name as per PAN"
                  error={
                    (touched?.panDetails?.fullName || '') &&
                    (errors?.panDetails?.fullName || '')
                  }
                  errorMsg={errors?.panDetails?.fullName || ''}
                  touched={touched?.panDetails?.fullName || ''}
                />
              </div>
              <div className="md:w-80 w-full my-4 mx-2">
                <CommonInput
                  name="panDetails.panNumber"
                  id="pan_no"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={data.panDetails.panNumber}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="PAN Number"
                  error={
                    (touched?.panDetails?.panNumber || '') &&
                    (errors?.panDetails?.panNumber || '')
                  }
                  errorMsg={errors?.panDetails?.panNumber || ''}
                  touched={touched?.panDetails?.panNumber || ''}
                />
              </div>
              <div className="md:w-80 w-full my-4 mx-2">
                <CommonInput
                  name="panDetails.fatherName"
                  id="fatherName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={data.panDetails.fatherName}
                  stylesContainer={{
                    height: '52px',
                    maxWidth: '100%'
                  }}
                  legendName="Father’s Name"
                  error={
                    (touched?.panDetails?.fatherName || '') &&
                    (errors?.panDetails?.fatherName || '')
                  }
                  errorMsg={errors?.panDetails?.fatherName || ''}
                  touched={touched?.panDetails?.fatherName || ''}
                />
              </div>
              <div
                className={
                  (errors?.panDetails?.fatherName || false
                    ? 'mt-6 '
                    : 'my-4 ') + ' DOB_field md:w-80 w-full  mx-2 '
                }
              >
                <div className=" absolute -mt-6 text-grey-1003">DOB</div>
                <CommonDatePicker
                  onChangeMonth={(value, isValidDate) => {
                    if (value.label !== 'Month') {
                      setFieldValue(
                        'panDetails.month',
                        {
                          value: Append_0(value.value, 2),
                          label: value.label
                        },
                        true
                      );
                      setFieldTouched('panDetails.month', true, false);
                    }
                    if (!isValidDate) {
                      setFieldValue(
                        'panDetails.month',
                        {
                          value: '',
                          label: 'Month'
                        },
                        true
                      );
                    }
                  }}
                  onChangeYear={(value, isValidDate) => {
                    if (value.label !== 'Year') {
                      setFieldValue(
                        'panDetails.year',
                        {
                          value: value.value,
                          label: value.label
                        },
                        true
                      );
                      setFieldTouched('panDetails.year', true, false);
                    }

                    if (!isValidDate) {
                      setFieldValue(
                        'panDetails.year',
                        {
                          value: '',
                          label: 'year'
                        },
                        true
                      );
                    }
                  }}
                  onChangeDate={value => {
                    if (value.label !== 'Date') {
                      setFieldValue(
                        'panDetails.date',
                        {
                          value: Append_0(value.value, 2),
                          label: value.label
                        },
                        true
                      );
                      setFieldTouched('panDetails.date', true, false);
                    }
                  }}
                  valueMonth={data.panDetails.month}
                  valueYear={data.panDetails.year}
                  valueDate={data.panDetails.date}
                  errorYear={
                    (touched?.panDetails?.year || '') &&
                    get(errors, 'panDetails.year.value', false)
                  }
                  touchedYear={touched?.panDetails?.year || ''}
                  onBlurYear={() => {
                    setFieldTouched('panDetails.year', true, true);
                  }}
                  errorMonth={
                    (touched?.panDetails?.month || '') &&
                    get(errors, 'panDetails.month.value', false)
                  }
                  touchedMonth={touched?.panDetails?.month || ''}
                  onBlurMonth={() => {
                    setFieldTouched('panDetails.month', true, true);
                  }}
                  errorDate={
                    (touched?.panDetails?.date || '') &&
                    get(errors, 'panDetails.date.value', false)
                  }
                  touchedDate={touched?.panDetails?.date || ''}
                  onBlurDate={() => {
                    setFieldTouched('panDetails.date', true, true);
                  }}
                  type="dob"
                />
              </div>
            </div>
          )}
          {/* button if want to modify get response */}
          <div className={hasDocuments ? 'block ' : 'hidden'}>
            <button
              type="submit"
              onClick={() => {
                setVerifying(true);
              }}
              disabled={!_.isEmpty(errors.panDetails)}
              className=" submitButton text-14 w-56 h-12 font-medium  font-roboto"
            >
              save and update
            </button>
          </div>
          {/* button for upload/ */}
          <div className={hasDocuments ? ' hidden' : ' '}>
            <button
              disabled={!fileUploaded ? true : !_.isEmpty(errors)}
              type={fileUploaded ? 'submit' : 'button'}
              onClick={() => {
                if (fileUploaded) setVerifying(true);
              }}
              className={
                (!fileUploaded ? ' hidden' : ' ') +
                ' submitButton text-14 w-56 h-12 font-medium  font-roboto'
              }
            >
              {fileUploaded ? 'Save & Verify' : 'Next'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default PanDetailsPage;
